import { getContaAcesso } from '../../config/Auth.js';

const INITIAL_STATE = INICIAR();

function INICIAR() {
    let data = getContaAcesso();

    if (
        !data ||
        !data.contaAcesso ||
        !data.contaAcesso.listaVinculo ||
        data.contaAcesso.listaVinculo[0] !== null
    ) {
        return {
            descTipoVinculo: '',
            descVinculo: '',
            idenVinculo: 0,
            numrVinculo: 0,
        };
    }

    return data.contaAcesso.listaVinculo[0];
}
function setVinculoSelecionado(state, action) {
    const newVinculoSelecionado = action.value ? action.value : null;
    return { ...state, ...newVinculoSelecionado };
}

function vinculoSelecionadoReducer(state = INITIAL_STATE, action) {
    if (action.type === 'SETVINCULO_SELECIONADO') {
        return setVinculoSelecionado(state, action);
    }
    return state;
}

export default vinculoSelecionadoReducer;
